import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { JQueryHTTPClient } from 'app/rest/JQueryHTTPClient';
import { EntityService } from 'app/rest/entity.service';
import { Rest } from 'app/rest/rest_client';
import { RestVehicleInventory } from './rest_vehicle-inventory';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
 })
export class EmployeeService extends EntityService<Rest.InvEmployee> {

	client: Rest.RestApplicationClient;
	 selectEmployee = new Subject();
	 employeeSelected = new Subject<Rest.InvEmployee>();

    constructor(private jquery: JQueryHTTPClient) {
      super();
      this.client = new Rest.RestApplicationClient(jquery);
    }

    create(arg0: Rest.InvEmployee): Rest.RestResponse<Rest.InvEmployee> {
        return this.client.Employee_create(arg0);
    }

    update(arg0: Rest.InvEmployee): Rest.RestResponse<Rest.InvEmployee> {
        return this.client.Employee_update(arg0);
    }

    getPage(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest.InvEmployee>> {
        return this.client.Employee_getPage(arg0);
    }

	getPageAndFilters(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.ListPageAndFilters<Rest.InvEmployee>> {
        return this.accessory.Employee_getPageAndFilters(arg0);
    }

	getPageAll(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest.InvEmployee>> {
        return this.client.Employee_getPageAll(arg0);
    }
    changeStatus(arg0: number[], queryParams?: { status?: boolean }): Rest.RestResponse<void> {
        return this.client.Employee_changeStatus(arg0, queryParams);
    }

    find(arg0: string, queryParams?: { id?: number }): Rest.RestResponse<Rest.InvEmployee> {
        return this.client.Employee_find(arg0, queryParams);
    }

	getList(clientId: number): Rest.RestResponse<Rest.InvEmployee[]> {
		return this.client.Employee_getList(clientId);
   }

}

